/**
 * 是否顯示 Apple Pay 按鈕：iPhone、訂單為 apple_pay、可付款——不要求在 LINE App 內
 *（外部 Safari 開 LIFF 連結登入後的 LINE 模式頁也要顯示；按下後由呼叫端的開啟邏輯依
 * liff.isInClient() 分流：LINE 內 liff.openWindow、否則 window.open）。
 * Safari（pt 模式）另用 TapPay checkAvailability，不經過這支函式。
 * devOverride：開發環境不受裝置限制（略過 os 檢查），方便非 iPhone 裝置測試 Kiosk 結帳；
 * 仍需符合 paymentMethod/payable 條件，不是無條件顯示。
 */
export const shouldOfferApplePayInLine = ({
  os,
  paymentMethod,
  payable,
  devOverride,
}: {
  os: string | null;
  paymentMethod: string | null;
  payable: boolean;
  devOverride?: boolean;
}): boolean => (devOverride || os === "ios") && paymentMethod === "apple_pay" && payable;

/** 訂單詳情頁是否需要查線上付款狀態：快照付款方式為信用卡或 Apple Pay 才查（現金到付／未知方式不查）。 */
export const shouldFetchPayStatus = (paymentMethod: string | null | undefined): boolean =>
  paymentMethod != null && ["credit_card", "apple_pay"].includes(paymentMethod);
